import { Navigate, useParams } from 'react-router';

/**
 * The helper-first booking route (/booking/:helperId → the old BookingWizard)
 * was retired in favour of the unified task-first flow (booking-journey-remake,
 * 2026-08-06). Any old link or bookmark now forwards into /booking-flow with
 * that helper pre-seeded, so the client describes the task first and the helper
 * is already selected at the helper step.
 */
export default function LegacyBookingRedirect() {
  const { helperId } = useParams();
  return <Navigate to={helperId ? `/booking-flow?helper=${helperId}` : '/booking-flow'} replace />;
}
